/* istanbul ignore file */

export const FORM_FIELDS = {
  HEADLINE: 'headline',
  STANDFIRST: 'standfirst',
  LANGUAGE: 'language',
  SELECTED_AUTHORS: 'selected_authors',
  CONTENT_BODY: 'content_body',
  BODY: 'body',
  IMGS: 'imgs',
  VIDEOS: 'videos',
  WEBSITES: 'websites',
  INTERNAL_INFORMATION: 'internal_information',
  LIVE_URLS: 'live_urls',
  CONTENT_IDS: 'content_ids',
  ARTICLE_VERSION_LIST: 'article_version_list',
  NEXT_STATES: 'next_states',
  SURTITLES: 'surtitles',
  EDITION_LANGUAGE: 'edition_language',
  TYPED_TAGS: 'typed_tags',
  TOPICS: 'topics',
  TOPICS_WITH_TRANSLATIONS: 'topics_with_translations',
  TAGS: 'tags',
  COMPANIES: 'companies',
  PEOPLE: 'people',
  PUBLISH: 'publish',
  DATE: 'date',
  TIMEZONE: 'timezone',
  SHOW_PUBLISH_TIME: 'show_publish_time',
  RESTRICTED_TO_REGISTERED_USERS: 'restrict_to_registered_users',
  NOT_FOR_GOOGLE_NEWS_SITEMAPS: 'not_for_google_news_sitemaps',
  NOT_FOR_NEWS_FEED: 'not_for_news_feeds',
  HIDE_THIS_ARTICLE: 'hide_this_article',
  PAYWALL_PREMIUM_CONTENT: 'paywall_premium_content',
  NOT_FOR_COMPETITORS: 'not_for_competitors',
  SPONSORED_HEADLINE: 'sponsored_headline',
  SPONSORED_BODY: 'sponsored_body',
  SPONSORED_IMGS: 'sponsored_imgs',
  SPONSORED_VIDEOS: 'sponsored_videos',
  SPONSORED_MAIN_IMAGE: 'sponsored_main_image',
  SPONSORED_MAIN_VIDEO: 'sponsored_main_video',
  SPONSORED_SALES_ORDER: 'sponsored_sales_order',
  SPONSORED_CLIENT: 'sponsored_client',
  SPONSORED_AUTHORS: 'sponsored_authors',
  SPONSORED_STANDFIRST: 'sponsored_standfirst',
};
